// src/composables/useServedFrom.js
// Tells the UI which origin the (offline-capable) app is actually served from,
// so an operator can see at a glance whether this is the real production
// deployment or a local/test build. Purely client-side — works with the backend
// fully offline, because the serving origin is only ever knowable in the browser.

// Canonical production origin. Hardcoded for now — there's no build/deploy
// pipeline injecting env vars yet, so a single source-of-truth constant is the
// honest representation. When a pipeline (e.g. Docker) exists and per-environment
// overrides are needed, swap this for `import.meta.env.VITE_CANONICAL_ORIGIN`.
const canonicalOrigin = 'https://pos.metactical.com';

// Exact-origin comparison (protocol + host + port), trailing-slash-normalised.
// `https://pos.metactical.com` matches; `http://…`, `www.…`, or any other host
// does not. Pure + exported so it can be unit-tested without a browser.
export function matchesCanonical(currentOrigin, expectedOrigin) {
  const strip = (s) => String(s || '').replace(/\/+$/, '');
  return strip(currentOrigin) === strip(expectedOrigin);
}

// Origin can't change during a session, so resolve everything once.
const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
const isCanonical = matchesCanonical(currentOrigin, canonicalOrigin);
const displayHost = typeof window !== 'undefined' ? window.location.host : '';

export function useServedFrom() {
  return { isCanonical, canonicalOrigin, currentOrigin, displayHost };
}
